import { IState, IUpdateEmailAttachmentsAction } from '../../../../types/state';

export const updateEmailAttachments = (state: IState, action: IUpdateEmailAttachmentsAction): IState => ({
    ...state,
    emailAttachments: [...action.attachments],
  });
